import React from 'react';
import { Box, Wrap, Stat, ColorSwatch, WrapItem, Text } from '@chakra-ui/react';
import { Chart, useChart } from '@chakra-ui/charts';
import { Pie, PieChart, Cell, Tooltip } from 'recharts';

interface UseChartProps {
  data: Array<{
    name: string;
    value: number;
  }>;
}

const DonuteChart: React.FC<UseChartProps> = ({ data }) => {
  const chart = useChart({
    data,
  });

  return (
    <Box>
      <Chart.Root chart={chart} boxSize="200px" mx="auto">
        {/* @chakra-ui/charts >= 3.31 no longer wraps children in ResponsiveContainer;
            without `responsive` (or explicit width/height) recharts renders no SVG. */}
        <PieChart responsive>
          <Pie
            data={chart.data}
            dataKey={chart.key("value")}
            nameKey="name"
            innerRadius={40}
            outerRadius={80}
          >
            {chart.data.map((item: any, index: number) => {
              return <Cell key={`${item.name}-${index}`} fill={chart.color(item.color)} />
            })}
          </Pie>
          <Tooltip
            cursor={false}
            animationDuration={100}
            formatter={(value: any) => `${value}%`}
            content={<Chart.Tooltip hideLabel />}
          />
        </PieChart>
      </Chart.Root>
      <Wrap justify="center" gap="3">
        {chart.data.map((item: any) => (
          <WrapItem key={item.name}>
            <Stat.Root size="sm">
              <Stat.Label textStyle="xs">
                <ColorSwatch boxSize="2" rounded="full" value={chart.color(item.color)} />
                {item.name} -<Text color="fg.muted">{item.value}%</Text>
              </Stat.Label>
            </Stat.Root>
          </WrapItem>
        ))}
      </Wrap>
    </Box>
  );
};

export default DonuteChart;
